import React from 'react'

const { WhereValueEditor } = require( './WhereValueEditor' )
const { WhereLogicEditor } = require( './WhereLogicEditor' )

const types = {
  [WhereValueEditor.TYPE] : WhereValueEditor,
  [WhereLogicEditor.TYPE] : WhereLogicEditor,
}

function queryFactory( where, props ) {
  // console.log( where )
  if ( Array.isArray( where ) ) {
    const Editor = where.length === 3 ? WhereValueEditor : WhereLogicEditor
    return <Editor where={where} {...props} />
  }
  return null
}

exports.factory = queryFactory
